// import moment from "moment-timezone";

// const DEFAULT_DISPLAY_FORMAT = "DD MMM YYYY, h:mm A";

// /**
//  * Prefer Intl (browser / OS). `moment.tz.guess()` often resolves to UTC in CI, some WebViews,
//  * React Native, or when TZ is unset — then schedule/punch UTC→"local" looks unchanged (e.g. 4am–1pm).
//  */
// export const getDefaultDisplayTimezone = () => {
//   try {
//     if (typeof Intl !== "undefined" && typeof Intl.DateTimeFormat === "function") {
//       const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
//       if (tz && typeof tz === "string") return tz;
//     }
//   } catch {
//     // ignore
//   }
//   return moment.tz.guess();
// };

// const TIME_ONLY_REGEX = /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/;
// const TIME_ONLY_AMPM_REGEX =
//   /^(0?[1-9]|1[0-2]):([0-5]\d)(:\d{2}(\.\d{1,3})?)?\s*([AaPp][Mm])$/;
// const ISO_WITHOUT_TIMEZONE_REGEX =
//   /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;
// const SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX =
//   /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;

// const normalizeTimeOnlyTo24h = (timeValue) => {
//   const trimmedValue = String(timeValue || "").trim();

//   const twentyFourHourMatch = trimmedValue.match(TIME_ONLY_REGEX);
//   if (twentyFourHourMatch) {
//     return {
//       hours: Number(twentyFourHourMatch[1]),
//       minutes: Number(twentyFourHourMatch[2]),
//       seconds: Number(twentyFourHourMatch[3] || 0),
//     };
//   }

//   const amPmMatch = trimmedValue.match(TIME_ONLY_AMPM_REGEX);
//   if (!amPmMatch) return null;

//   // Groups: [1]=hour, [2]=min, [3]=optional :ss, [4]=optional fraction, [5]=AM|PM
//   const hour12 = Number(amPmMatch[1]);
//   const meridiem = String(amPmMatch[5] || "").toLowerCase();
//   let hours = hour12 % 12;
//   if (meridiem === "pm") hours += 12;

//   let seconds = 0;
//   if (amPmMatch[3]) {
//     const raw = String(amPmMatch[3]).replace(/^:/, "").split(".")[0];
//     const s = Number(raw);
//     seconds = Number.isFinite(s) ? s : 0;
//   }

//   return {
//     hours,
//     minutes: Number(amPmMatch[2]),
//     seconds,
//   };
// };

// /**
//  * Normalizes API / storage values so moment parses them as UTC (instant),
//  * then callers can shift to local for display.
//  */
// const normalizeUtcInputString = (utcDateTime) => {
//   if (
//     utcDateTime === null ||
//     utcDateTime === undefined ||
//     utcDateTime === ""
//   ) {
//     return null;
//   }

//   if (utcDateTime instanceof Date || typeof utcDateTime === "number") {
//     return utcDateTime;
//   }

//   if (typeof utcDateTime !== "string") {
//     return null;
//   }

//   const trimmedValue = utcDateTime.trim();
//   if (!trimmedValue) return null;

//   const normalizedTime = normalizeTimeOnlyTo24h(trimmedValue);

//   if (normalizedTime) {
//     const h = String(normalizedTime.hours).padStart(2, "0");
//     const m = String(normalizedTime.minutes).padStart(2, "0");
//     const s = String(normalizedTime.seconds).padStart(2, "0");
//     return `1970-01-01T${h}:${m}:${s}Z`;
//   }

//   if (
//     ISO_WITHOUT_TIMEZONE_REGEX.test(trimmedValue) ||
//     SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX.test(trimmedValue)
//   ) {
//     const withT = trimmedValue.includes(" ")
//       ? trimmedValue.replace(" ", "T")
//       : trimmedValue;
//     return `${withT}Z`;
//   }

//   return trimmedValue;
// };

// /**
//  * Interprets a local wall-clock value in `timezone` and returns an ISO-8601 UTC string (for APIs / storage).
//  * For `Date` / epoch ms: converts that instant to UTC (prefer passing a Date built from `new Date('yyyy-mm-ddThh:mm:ss')`
//  * so it matches the browser’s local calendar/time — no separate TZ library required).
//  * Supports time-only ("17:00"), naive ISO strings (parsed in `timezone`), and strings with offset/Z.
//  */
// export const convertLocalDateTimeToUTC = (
//   localDateTime,
//   { timezone = getDefaultDisplayTimezone() } = {}
// ) => {
//   if (
//     localDateTime === null ||
//     localDateTime === undefined ||
//     localDateTime === ""
//   ) {
//     return null;
//   }

//   if (localDateTime instanceof Date || typeof localDateTime === "number") {
//     const m = moment.utc(localDateTime);
//     return m.isValid() ? m.toISOString() : null;
//   }

//   if (typeof localDateTime !== "string") {
//     return null;
//   }

//   const trimmedValue = localDateTime.trim();
//   if (!trimmedValue) return null;

//   const normalizedTime = normalizeTimeOnlyTo24h(trimmedValue);
//   if (normalizedTime) {
//     const h = String(normalizedTime.hours).padStart(2, "0");
//     const m = String(normalizedTime.minutes).padStart(2, "0");
//     const s = String(normalizedTime.seconds).padStart(2, "0");
//     const today = moment.tz(timezone).format("YYYY-MM-DD");
//     const localM = moment.tz(`${today}T${h}:${m}:${s}`, timezone);
//     return localM.isValid() ? localM.utc().toISOString() : null;
//   }

//   if (
//     ISO_WITHOUT_TIMEZONE_REGEX.test(trimmedValue) ||
//     SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX.test(trimmedValue)
//   ) {
//     const withT = trimmedValue.includes(" ")
//       ? trimmedValue.replace(" ", "T")
//       : trimmedValue;
//     const localM = moment.tz(withT, timezone);
//     return localM.isValid() ? localM.utc().toISOString() : null;
//   }

//   const parsed = moment.parseZone(trimmedValue);
//   if (!parsed.isValid()) return null;
//   return parsed.utc().toISOString();
// };

// /**
//  * Parses stored/API UTC and formats for display in `timezone` (default: Intl zone, else moment.tz.guess()).
//  * Use `formatOptions` + optional `locale` for Intl-style output (used across the app); otherwise `format` (moment).
//  */
// export const convertUTCToLocalDateTime = (
//   utcDateTime,
//   {
//     timezone = getDefaultDisplayTimezone(),
//     format = DEFAULT_DISPLAY_FORMAT,
//     locale,
//     formatOptions,
//   } = {}
// ) => {
//   if (
//     utcDateTime === null ||
//     utcDateTime === undefined ||
//     utcDateTime === ""
//   ) {
//     return "—";
//   }

//   const normalized = normalizeUtcInputString(utcDateTime);
//   if (normalized === null) return "—";

//   const utcMoment = moment.utc(normalized);

//   if (!utcMoment.isValid()) return "—";

//   if (formatOptions && typeof formatOptions === "object") {
//     const instant = utcMoment.toDate();
//     try {
//       const intlOpts = {
//         ...formatOptions,
//         timeZone: timezone,
//       };
//       // Avoid ambiguous 12h output across locales/browsers when callers set hour12
//       if (intlOpts.hour12 === true && intlOpts.hourCycle == null) {
//         intlOpts.hourCycle = "h12";
//       }
//       if (intlOpts.hour12 === false && intlOpts.hourCycle == null) {
//         intlOpts.hourCycle = "h23";
//       }
//       return new Intl.DateTimeFormat(locale || undefined, intlOpts).format(
//         instant
//       );
//     } catch {
//       return utcMoment.tz(timezone).format(format);
//     }
//   }

//   return utcMoment.tz(timezone).format(format);
// };

// const SCHEDULE_BOUNDARY_TIME_FORMAT = {
//   hour: "numeric",
//   minute: "2-digit",
//   hour12: true,
// };

// const padScheduleHms = (timeHms) => {
//   const raw = String(timeHms || "").trim();
//   const base = raw.includes(".") ? raw.replace(/\.\d+$/, "") : raw;
//   const parts = base.split(":");
//   const h = String(parts[0] ?? "0").padStart(2, "0");
//   const mi = String(parts[1] ?? "0").padStart(2, "0");
//   const s = String(parts[2] ?? "0").replace(/\D/g, "").slice(0, 2).padStart(2, "0") || "00";
//   return `${h}:${mi}:${s}`;
// };

// const isUtcLikeTimezone = (tz) => {
//   if (tz == null || tz === "") return true;
//   const z = String(tz).trim().toUpperCase();
//   return (
//     z === "UTC" ||
//     z === "GMT" ||
//     z === "Z" ||
//     z === "ETC/UTC" ||
//     z === "ETC/GMT" ||
//     z === "GREENWICH"
//   );
// };

// const formatTimeOnlyFallback12h = (timeHms) => {
//   const base = String(timeHms || "").trim();
//   if (!base) return "";
//   const m = moment(base, ["HH:mm:ss", "H:mm:ss", "HH:mm", "H:mm"], true);
//   return m.isValid() ? m.format("h:mm a") : base;
// };

// /**
//  * Formats a schedule boundary (calendar date + `HH:mm[:ss]` in `sourceTimezone`) for display in
//  * `displayTimezone` (default device). When `sourceTimezone` is UTC-like, date+time are treated as a UTC
//  * instant (same convention as `scheduleReference` in the attendance API). For IANA zones, the time is
//  * interpreted as wall clock in that zone on that date, then shown in the display zone.
//  */
// const EMPTY_DISPLAY = "\u2014";

// const isEmptyDisplayToken = (value) =>
//   value == null ||
//   value === "" ||
//   value === EMPTY_DISPLAY ||
//   value === "—";

// export const formatScheduleBoundaryForDisplay = (
//   calendarDate,
//   timeHms,
//   {
//     sourceTimezone = "UTC",
//     displayTimezone = getDefaultDisplayTimezone(),
//     formatOptions = SCHEDULE_BOUNDARY_TIME_FORMAT,
//     locale,
//   } = {}
// ) => {
//   if (timeHms == null || timeHms === "") return "";
//   const hms = padScheduleHms(timeHms);
//   const dateMatch =
//     calendarDate != null && calendarDate !== ""
//       ? String(calendarDate).trim().match(/^(\d{4}-\d{2}-\d{2})/)
//       : null;
//   const datePart = dateMatch ? dateMatch[1] : "";

//   if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
//     return formatTimeOnlyFallback12h(timeHms);
//   }

//   const displayTz =
//     displayTimezone != null && displayTimezone !== ""
//       ? displayTimezone
//       : getDefaultDisplayTimezone();

//   const srcTz = String(sourceTimezone ?? "UTC").trim();
//   let utcInput;

//   if (isUtcLikeTimezone(srcTz)) {
//     utcInput = `${datePart}T${hms}Z`;
//   } else if (moment.tz.zone(srcTz)) {
//     const wall = moment.tz(`${datePart}T${hms}`, srcTz);
//     if (!wall.isValid()) return formatTimeOnlyFallback12h(timeHms);
//     utcInput = wall.utc().toISOString();
//   } else {
//     utcInput = `${datePart}T${hms}Z`;
//   }

//   const out = convertUTCToLocalDateTime(utcInput, {
//     timezone: displayTz,
//     formatOptions,
//     locale,
//   });
//   return isEmptyDisplayToken(out) ? formatTimeOnlyFallback12h(timeHms) : out;
// };






import moment from "moment-timezone";

const DEFAULT_DISPLAY_FORMAT = "DD MMM YYYY, h:mm A";

const TIME_ONLY_REGEX = /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/;
const TIME_ONLY_AMPM_REGEX =
  /^(0?[1-9]|1[0-2]):([0-5]\d)(:\d{2}(\.\d{1,3})?)?\s*([AaPp][Mm])$/;
const ISO_WITHOUT_TIMEZONE_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;
const SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX =
  /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;

const normalizeTimeOnlyTo24h = (timeValue) => {
  const trimmedValue = String(timeValue || "").trim();

  const twentyFourHourMatch = trimmedValue.match(TIME_ONLY_REGEX);
  if (twentyFourHourMatch) {
    return {
      hours: Number(twentyFourHourMatch[1]),
      minutes: Number(twentyFourHourMatch[2]),
      seconds: Number(twentyFourHourMatch[3] || 0),
    };
  }

  const amPmMatch = trimmedValue.match(TIME_ONLY_AMPM_REGEX);
  if (!amPmMatch) return null;

  // Groups: [1]=hour, [2]=min, [3]=optional :ss, [4]=optional fraction, [5]=AM|PM
  const hour12 = Number(amPmMatch[1]);
  const meridiem = String(amPmMatch[5] || "").toLowerCase();
  let hours = hour12 % 12;
  if (meridiem === "pm") hours += 12;

  let seconds = 0;
  if (amPmMatch[3]) {
    const raw = String(amPmMatch[3]).replace(/^:/, "").split(".")[0];
    const s = Number(raw);
    seconds = Number.isFinite(s) ? s : 0;
  }

  return {
    hours,
    minutes: Number(amPmMatch[2]),
    seconds,
  };
};

/**
 * Normalizes API / storage values so moment parses them as UTC (instant),
 * then callers can shift to local for display.
 */
const normalizeUtcInputString = (utcDateTime) => {
  if (
    utcDateTime === null ||
    utcDateTime === undefined ||
    utcDateTime === ""
  ) {
    return null;
  }

  if (utcDateTime instanceof Date || typeof utcDateTime === "number") {
    return utcDateTime;
  }

  if (typeof utcDateTime !== "string") {
    return null;
  }

  const trimmedValue = utcDateTime.trim();
  if (!trimmedValue) return null;

  const normalizedTime = normalizeTimeOnlyTo24h(trimmedValue);

  if (normalizedTime) {
    const h = String(normalizedTime.hours).padStart(2, "0");
    const m = String(normalizedTime.minutes).padStart(2, "0");
    const s = String(normalizedTime.seconds).padStart(2, "0");
    return `1970-01-01T${h}:${m}:${s}Z`;
  }

  if (
    ISO_WITHOUT_TIMEZONE_REGEX.test(trimmedValue) ||
    SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX.test(trimmedValue)
  ) {
    const withT = trimmedValue.includes(" ")
      ? trimmedValue.replace(" ", "T")
      : trimmedValue;
    return `${withT}Z`;
  }

  return trimmedValue;
};

/**
 * Interprets a local wall-clock value in `timezone` and returns an ISO-8601 UTC string (for APIs / storage).
 * For `Date` / epoch ms: converts that instant to UTC (prefer passing a Date built from `new Date('yyyy-mm-ddThh:mm:ss')`
 * so it matches the browser’s local calendar/time — no separate TZ library required).
 * Supports time-only ("17:00"), naive ISO strings (parsed in `timezone`), and strings with offset/Z.
 */
export const convertLocalDateTimeToUTC = (
  localDateTime,
  { timezone = moment.tz.guess() } = {}
) => {
  if (
    localDateTime === null ||
    localDateTime === undefined ||
    localDateTime === ""
  ) {
    return null;
  }

  if (localDateTime instanceof Date || typeof localDateTime === "number") {
    const m = moment.utc(localDateTime);
    return m.isValid() ? m.toISOString() : null;
  }

  if (typeof localDateTime !== "string") {
    return null;
  }

  const trimmedValue = localDateTime.trim();
  if (!trimmedValue) return null;

  const normalizedTime = normalizeTimeOnlyTo24h(trimmedValue);
  if (normalizedTime) {
    const h = String(normalizedTime.hours).padStart(2, "0");
    const m = String(normalizedTime.minutes).padStart(2, "0");
    const s = String(normalizedTime.seconds).padStart(2, "0");
    const today = moment.tz(timezone).format("YYYY-MM-DD");
    const localM = moment.tz(`${today}T${h}:${m}:${s}`, timezone);
    return localM.isValid() ? localM.utc().toISOString() : null;
  }

  if (
    ISO_WITHOUT_TIMEZONE_REGEX.test(trimmedValue) ||
    SPACE_DATETIME_WITHOUT_TIMEZONE_REGEX.test(trimmedValue)
  ) {
    const withT = trimmedValue.includes(" ")
      ? trimmedValue.replace(" ", "T")
      : trimmedValue;
    const localM = moment.tz(withT, timezone);
    return localM.isValid() ? localM.utc().toISOString() : null;
  }

  const parsed = moment.parseZone(trimmedValue);
  if (!parsed.isValid()) return null;
  return parsed.utc().toISOString();
};

/**
 * Parses stored/API UTC and formats for display in `timezone` (default: device local via moment.tz.guess()).
 * Use `formatOptions` + optional `locale` for Intl-style output (used across the app); otherwise `format` (moment).
 */
export const convertUTCToLocalDateTime = (
  utcDateTime,
  {
    timezone = moment.tz.guess(),
    format = DEFAULT_DISPLAY_FORMAT,
    locale,
    formatOptions,
  } = {}
) => {
  if (
    utcDateTime === null ||
    utcDateTime === undefined ||
    utcDateTime === ""
  ) {
    return "—";
  }

  const normalized = normalizeUtcInputString(utcDateTime);
  if (normalized === null) return "—";

  const utcMoment = moment.utc(normalized);

  if (!utcMoment.isValid()) return "—";

  if (formatOptions && typeof formatOptions === "object") {
    const instant = utcMoment.toDate();
    try {
      const intlOpts = {
        ...formatOptions,
        timeZone: timezone,
      };
      // Avoid ambiguous 12h output across locales/browsers when callers set hour12
      if (intlOpts.hour12 === true && intlOpts.hourCycle == null) {
        intlOpts.hourCycle = "h12";
      }
      if (intlOpts.hour12 === false && intlOpts.hourCycle == null) {
        intlOpts.hourCycle = "h23";
      }
      return new Intl.DateTimeFormat(locale || undefined, intlOpts).format(
        instant
      );
    } catch {
      return utcMoment.tz(timezone).format(format);
    }
  }

  return utcMoment.tz(timezone).format(format);
};

/** e.g. 90 → "1 h 30 min", 45 → "45 min", 120 → "2 h" */
export function formatDurationMinutes(totalMinutes) {
  if (totalMinutes == null || totalMinutes === "") return null;
  const n = Math.floor(Number(totalMinutes));
  if (!Number.isFinite(n) || n < 0) return null;
  if (n === 0) return "0 min";

  const hours = Math.floor(n / 60);
  const minutes = n % 60;

  if (hours > 0 && minutes > 0) return `${hours} h ${minutes} min`;
  if (hours > 0) return `${hours} h`;
  return `${minutes} min`;
}

/** Parses minutes from a number, decimal hours, or clock string (e.g. "00:03", "1:30:00"). */
export function parseDurationToMinutes(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) return Math.floor(value);
  const s = String(value).trim();
  if (/^\d+(\.\d+)?$/.test(s)) {
    const n = Number(s);
    if (!Number.isFinite(n)) return null;
    return n <= 24 && s.includes(".") ? Math.round(n * 60) : Math.floor(n);
  }
  const hms = s.match(/^(\d+):(\d{2})(?::(\d{2}))?$/);
  if (hms) {
    return (
      (parseInt(hms[1], 10) || 0) * 60 +
      (parseInt(hms[2], 10) || 0) +
      (hms[3] ? Math.floor(parseInt(hms[3], 10) / 60) : 0)
    );
  }
  const hoursSuffix = s.match(/^(\d+(?:\.\d+)?)\s*h$/i);
  if (hoursSuffix) return Math.round(Number(hoursSuffix[1]) * 60);
  return null;
}

export function hoursDecimalToMinutes(hours) {
  const n = Number(hours);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 60);
}
